import React from "react";

import { css } from "@emotion/react";
import { SwarovskiButton } from "../../_shared-components/ui-elements/SwarovskiButton";
import { Link } from "@swo/shared";
import { jsHooks } from "@swo/shared";

export const HeroImageCallToAction: React.FC<Link> = props => {
  return (
    <span
      css={css`
        margin-bottom: 20px;
        display: block;
      `}
    >
      <SwarovskiButton
        as="a"
        link={props.data}
        isInternal={props.type === "Internal Link"}
        variant={"normal"}
        className={jsHooks.heroImageCta}
        target={props.openInNewTab ? "_blank" : undefined}
      >
        {props.label}
      </SwarovskiButton>
    </span>
  );
};
